// icon:dash | Bootstrap https://icons.getbootstrap.com/ | Bootstrap
import * as React from "react";

function IconDash(props) {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 16 16"
      height="1em"
      width="1em"
      {...props}
    >
      <path d="M4 8a.5.5 0 01.5-.5h7a.5.5 0 010 1h-7A.5.5 0 014 8z" />
    </svg>
  );
}

export default IconDash;
